import * as React from 'react';
import { useQuery } from "react-query";

import { fetchClientContactsNotification } from 'utils/queries';

import MultiSelect from './MultiSelect';


const MultiSelectMailContactClient = ({ onChange, label, clientId, suiviEmail }) => {

    // Récupération des contacts du client
    const fetchContacts = useQuery('fetchClientContactsNotification', () => fetchClientContactsNotification(clientId));

    if (fetchContacts.isLoading || fetchContacts.error) {
        return null;
    }

    return (
        <MultiSelect
            arrayItems={fetchContacts.data}
            defaultValue={suiviEmail}
            isEmailsList={true}
            filterFoussierEmail={true}
            label={label}
            onChange={onChange}
        />
    );
}

export default MultiSelectMailContactClient;
